import { render, staticRenderFns } from "./form-bankaccount.vue?vue&type=template&id=a5f4699c&"
import script from "./form-bankaccount.vue?vue&type=script&lang=js&"
export * from "./form-bankaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports